/**
 * Split a filename into base name and extension.
 * "document.pdf"   → { base: "document", ext: ".pdf" }
 * "archive.tar.gz" → { base: "archive.tar", ext: ".gz" }
 * ".hidden"        → { base: ".hidden", ext: "" }
 */
export function splitFileName(name: string): { base: string; ext: string } {
  const dot = name.lastIndexOf(".");
  if (dot <= 0) return { base: name, ext: "" };
  return { base: name.slice(0, dot), ext: name.slice(dot) };
}

/**
 * Given a filename that conflicts with an existing file, suggest the next
 * available name by appending " (N)" before the extension.
 *
 * Example:
 *   buildSuggestedName("report.pdf", new Set(["report.pdf", "report (1).pdf"]))
 *   → "report (2).pdf"
 */
export function buildSuggestedName(
  conflictingName: string,
  allExistingNames: Set<string>
): string {
  const { base, ext } = splitFileName(conflictingName);

  // Strip any existing "(N)" suffix so we don't double-append
  const cleanBase = base.replace(/ \(\d+\)$/, "");

  for (let i = 1; i <= 9999; i++) {
    const candidate = `${cleanBase} (${i})${ext}`;
    if (!allExistingNames.has(candidate)) return candidate;
  }

  return `${cleanBase} (copy)${ext}`;
}
